import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Loading from "../../atoms/loading";
import UserInfo from "./userInfo";
import ProductInfo from "./productInfo";
import ProductSerials from "./productSerials";
import { STORES_URL } from "../../../context/paths";
import Button from "../../atoms/button";
import ProductComments from "./productComments";
import ProductAttachments from "./productAttachments";
import { getOrderAdapter } from "../../orders/orderAdapters";

/** Página de pedido única (spec 2026-10-01 §3.2): grading em /manafix/products/:id, arte estendida em /manafix/extended-art/:id. */
const OrderPage = ({ user, kind = "grading" }) => {

    const { id } = useParams();
    const navigate = useNavigate();
    const adapter = getOrderAdapter(kind);

    const [productData, setProductData] = useState(null);
    const [stores, setStores] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        doGetProduct();
        getStores();
        // eslint-disable-next-line
    }, [])

    const doGetProduct = async () => {
        setLoading(true);
        const data = await adapter.load(user?.token, id);
        if (data?.type !== "success") {
            setError(adapter.loadErrorMessage(data));
            setLoading(false);
            return null;
        }
        setProductData(data?.data);
        setLoading(false);
    }

    const getStores = async () => {
        const storesOptions = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${user.token}`
            }
        }
        try {
            const response = await fetch(STORES_URL, storesOptions);
            const data = await response.json();
            if (data.type === "success") {
                setStores(data.data);
            }

        } catch (e) {
            console.log("erro");
        }
    }

    const navigateToUser = (blank) => {
        if (blank) {
            window.open(`/manafix/users/${productData?.user?._id}`, "_blank");
            return null;
        }
        navigate(`/manafix/users/${productData?.user?._id}`);
    }

    const handleMouseDown = (e) => {
        if (e?.button === 1) {
            navigateToUser(true);
        }
    }

    if (error) {
        return (
            <main>
                <h1 className="border-b border-primary text-center">{adapter.title}</h1>
                <p className="text-center text-red-500 mt-4">{error}</p>
            </main>
        )
    }

    if (loading) {
        return (
            <main>
                <h1 className="border-b border-primary text-center">{adapter.title}</h1>
                <div className="m-auto w-fit mt-10">
                    <Loading />
                </div>
            </main>
        )
    }

    return (
        <main className="mb-10">
            <h1 className="border-b border-primary text-center text-lg font-bold">{adapter.title}</h1>
            <div>
                <div className="relative">
                    <UserInfo userData={productData?.user} />
                    <div onMouseDown={handleMouseDown} className="absolute top-2 right-6">
                        <Button classes="bg-primary" click={() => navigateToUser(false)}>Ver</Button>
                    </div>
                </div>
                <ProductComments productData={productData} refresh={doGetProduct} adapter={adapter} />
                <ProductAttachments productData={productData} refresh={doGetProduct} adapter={adapter} />
                <ProductInfo user={user} refresh={doGetProduct} productData={productData} stores={stores} adapter={adapter} />
                <ProductSerials user={user} productData={productData} setProductData={setProductData} adapter={adapter}/>
            </div>
        </main>
    )
}

export default OrderPage;
